module.exports = __webpack_public_path__ + "img/en.4838c381.png";